/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as roomActions from '../actions/roomActions';

export function useRoomMetadata(roomId: string): { isLoading: boolean } {
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  useEffect(() => {
    async function fetchRoomMetadata() {
      await roomActions.fetchRoomMetadata(roomId)(dispatch);
      setIsLoading(false);
    }
    fetchRoomMetadata();
  }, [dispatch, roomId]);
  return { isLoading };
}
